import { useEffect, useRef, useState } from 'react';
import { useRouter } from 'expo-router';
import { useBusinessWorkspace, businessChatPath } from './BusinessWorkspaceContext';
import { requestKey } from './businessRequestKey';

export function useNewBusinessChat(onNavigate) {
  const context = useBusinessWorkspace(), router = useRouter(), pending = useRef(false), key = useRef(null);
  const [busy, setBusy] = useState(false), [error, setError] = useState(null);
  const { api, workspaceId, current } = context;
  const generation = useRef(0);
  useEffect(() => () => { generation.current++; }, []);
  const create = async () => {
    if (pending.current) return;
    pending.current = true; setBusy(true); setError(null); key.current ||= requestKey();
    const ticket = generation.current, isRequestCurrent = () => current() && ticket === generation.current;
    try {
      const chat = await api.createChat(workspaceId, key.current, { isRequestCurrent });
      if (isRequestCurrent()) {
        key.current = null; context.changed(); router.push(businessChatPath(workspaceId, chat.id)); onNavigate?.();
      }
    } catch (error) { if (isRequestCurrent()) setError(error.message); }
    finally { if (isRequestCurrent()) { pending.current = false; setBusy(false); } }
  };
  return { create, busy, error };
}
